/**
 * WordPress dependencies
 */
import { __ } from '@wordpress/i18n';
import {
  __experimentalToggleGroupControl as ToggleGroupControls,
  __experimentalToggleGroupControlOptionIcon as ToggleGroupControlOptionIcon,
} from '@wordpress/components';
import { Icon,justifyCenter,justifyLeft, justifyRight, justifyStretch ,justifySpaceBetween} from '@wordpress/icons';
import {useState } from '@wordpress/element';

/**
 * Internal dependencies
 */
import { VayuBlocksDevice,VayuBlocksDeviceControl } from '@vayu-blocks/device-control';


/**
 *  Component
 * json variable defiend like aligment is key 
 *  "alignment": {
 * 		"type": "object",
 *		"Desktop":"",
 *		"Tablet": "",
 *		"Mobile": ""
 *	}
    *
    * @param {VayuBlocksAlignment}
    * @param {setAttributes = setAttributes }
    * @param {alignment} - key and value of json object
    * @param {label="Text Alignment"} - label of control name
    * @param {options={ justify: __('justify', 'vayu-blocks')}} - options of control default is left,center,right and other add justify
    * 
        * 
        * @example
        * <VayuBlocksAlignment
        * setAttributes={setAttributes}
        * alignment = {key: 'alignment', value: attributes.alignment}
        * label="Alignment"
        * options={{ justify: __('justify', 'vayu-blocks')}}
        * />
        *   
        * 
 */

 export const VayuBlocksAlignment = ({
    onChange,
    alignment={},
    label=__('Alignment', 'vayu-blocks'), 
    options={},
}) => {
    const deviceView  = VayuBlocksDevice();
    const [firstDesktop, setFirstDesktop] = useState(false);
    const [firstTablet, setFirstTablet] = useState(false);

    const defaultOptions = {
        left: __('Left', 'vayu-blocks'),
        right: __('Right', 'vayu-blocks'),
        center: __('Center', 'vayu-blocks'),
    }
    const mergedOptions = { ...defaultOptions, ...options };

    const handelToggleGroupAlignment = () => alignment?.value?.[deviceView] ?? undefined;

    const handelToggleAttributes = (changeValue) => {
        const isFirstRun = alignment?.value?.[deviceView] === undefined;
        const isTabletFirstRun = localStorage.getItem('firstTablet') || firstTablet;
    
        let updatedAttributes = { ...alignment.value };
    
        if (deviceView === 'Desktop') {
            if (isFirstRun || firstDesktop) {
                updatedAttributes = { Desktop: changeValue, Tablet: changeValue, Mobile: changeValue };
                setFirstDesktop(true);
                setFirstTablet(true);
                localStorage.setItem('firstTablet', true);
            } else {
                updatedAttributes.Desktop = changeValue;
            }
        } 
        else if (deviceView === 'Tablet') {
            if (isTabletFirstRun) {
                updatedAttributes = { ...alignment.value, Tablet: changeValue, Mobile: changeValue };
                setFirstTablet(true);
                setFirstDesktop(false);
                localStorage.removeItem('firstTablet');
            } else {
                updatedAttributes.Tablet = changeValue;
            }
        } 
        else if (deviceView === 'Mobile') {
            updatedAttributes.Mobile = changeValue;
            setFirstDesktop(false);
            setFirstTablet(false);
            localStorage.removeItem('firstTablet');
        }
    
       // setAttributes({ [alignment.key]: updatedAttributes });
       onChange(alignment.key, updatedAttributes);
    };

    return (
        <div className='alignment-component-vb'>
            <ToggleGroupControls
             __next40pxDefaultSize
             __nextHasNoMarginBottom
            isBlock
            label={<div className="vayu_blocks_resnponsive_fix"><VayuBlocksDeviceControl label={__(label, 'vayu-blocks')} /></div>}
            value={ handelToggleGroupAlignment()}
            onChange={handelToggleAttributes}
            >
            {mergedOptions.hasOwnProperty('left') && <ToggleGroupControlOptionIcon
                icon={<Icon icon={ justifyLeft } />}
                label={mergedOptions.left}
                value="left"
            />}
            {mergedOptions.hasOwnProperty('center') &&<ToggleGroupControlOptionIcon
            icon={<Icon icon={ justifyCenter } />}
                label={mergedOptions.center}
                value="center"
            />}
            {mergedOptions.hasOwnProperty('right') &&<ToggleGroupControlOptionIcon
            icon={<Icon icon={ justifyRight } />}
                label={mergedOptions.right}
                value="right"
            />}
            {mergedOptions.hasOwnProperty('justify') &&<ToggleGroupControlOptionIcon
                icon={<Icon icon={ justifyStretch } />}
                label={mergedOptions.justify}
                value="justify"
            />}

            {mergedOptions.hasOwnProperty('spaceBetween') &&<ToggleGroupControlOptionIcon
                icon={<Icon icon={ justifySpaceBetween } />}
                label={mergedOptions.spaceBetween}
                value="space-between"
            />}
            </ToggleGroupControls>

        </div>
    );
};
